export type {
  BreadcrumbDividerSlots,
  BreadcrumbDividerBaseProps as BreadcrumbDividerProps,
  BreadcrumbDividerBaseState as BreadcrumbDividerState,
} from '@fluentui/react-breadcrumb';
